module.exports = ".course-content-header {\n  cursor: pointer; }\n"